import React from 'react';
import PropTypes from 'prop-types';

const ResponsiblePersons = ({ theme }) => (
    <section aria-label="Ansvarlige personer" className={theme.aboutvg}>
        <h1 className={theme.headline}>Ansvarlige personer</h1>
        <div className={theme.lighthr}>
            <dl>
                <dt>Ansv. redaktør og adm. direktør:</dt>
                <dd>
                    <a href="mailto:Gard.Steiro@vg.no">Gard Steiro</a>
                </dd>
                <dt>Nyhetsredaktør:</dt>
                <dd>
                    <a href="mailto:Tora.Bakke.Handlykken@vg.no">Tora Bakke Håndlykken</a>
                </dd>
                <dt>Utviklingsredaktør:</dt>
                <dd>
                    <a href="mailto:Ola.Stenberg@vg.no">Ola E. Stenberg</a>
                </dd>
                <dt>Featureredaktør:</dt>
                <dd>
                    <a href="mailto:Jane.Throndsen@vg.no">Jane Throndsen</a>
                </dd>
                <dt>Politisk redaktør:</dt>
                <dd>
                    <a href="mailto:Hanne.Skartveit@vg.no">Hanne Skartveit</a>
                </dd>
            </dl>
        </div>
        <div className={theme.darkhr}>
            <p>
                VG arbeider etter{' '}
                <a href="http://presse.no/pfu/etiske-regler/vaer-varsom-plakaten/">
                    Vær varsom-plakatens
                </a>{' '}
                regler for god presseskikk. VG har ikke ansvar for innhold på eksterne nettsider som
                det lenkes til. Kopiering av materiale fra VG for bruk annet sted er ikke tillatt
                uten avtale.
            </p>
        </div>

        <h2>Tips oss!</h2>
        <div className={theme.darkhr}>
            <dl>
                <dt>Send tips online</dt>
                <dd>
                    <a href="https://support.pluss.vg.no/hc/no/requests/new">Bruk skjema</a>
                </dd>
                <dt>SMS / MMS</dt>
                <dd>
                    <a href="tel:2200">2200</a>
                </dd>
                <dt>Ring</dt>
                <dd>
                    <a href="tel:22000000">22 00 00 00</a>
                </dd>
                <dt>E-post til</dt>
                <dd>
                    <a href="mailto:2200@vg.no">tusentipset</a>
                </dd>
            </dl>
        </div>

        <div className={theme.darkhr}>
            <a href="/om-vg/kontakt-oss/" className={theme.contactButton}>
                Kontakt oss
            </a>
        </div>
    </section>
);

ResponsiblePersons.propTypes = {
    theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

ResponsiblePersons.defaultProps = {
    theme: {},
};

export default ResponsiblePersons;



/** WEBPACK FOOTER **
 ** ./src/local-components/about/ResponsiblePersons.js
 **/